import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="bg-white text-gray-800 font-sans">
      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* Logo + Phone */}
        {/* <div className="flex md:flex-row flex-col gap-4 items-center justify-between mb-8">
          <img
            src="../Assets/logo_.webp"
            alt="Logo"
            className="w-44 h-auto"
          />
          <a
            href="tel:+971527195327"
            className="flex items-center space-x-2 text-white bg-[#997736] hover:bg-[#997736]/70 px-4 py-2 rounded-md shadow"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="currentColor"
              viewBox="0 0 512 512"
            >
              <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z" />
            </svg>
            <span>+971 52 719 5327</span>
          </a>
        </div> */}

        {/* Title */}
        <h2 className="md:text-5xl text-3xl text-center font-bold mb-10">
          Privacy Policy | Terms and Conditions
        </h2>

        {/* Content */}
        <div className="space-y-6 text-justify leading-relaxed">
          <p className="text-lg">
            <strong className="text-2xl">PRIVACY POLICY &amp; TERM OF USES</strong>
            <br />
            By accessing or using this landing page, you acknowledge and agree to abide by the following terms and conditions. </p>
          <p className="text-lg">
            <strong className="text-2xl">Intellectual Property Rights</strong>
            <br />
            All content, images, logos, and materials displayed on this landing page are the exclusive property of the real estate company or its licensors and are safeguarded by intellectual property laws. Unauthorized copying, modification, distribution, or usage of any content is strictly prohibited without prior written consent.</p>
          <p className="text-lg">
            <strong className="text-2xl">Property Information Disclaimer</strong>
            <br />
            The information provided on this landing page, including property descriptions, prices, availability, and other details, is subject to change without prior notice. The real estate company shall not be held accountable for any inaccuracies or omissions in the information provided.
          </p>
          <p className="text-lg">
            <strong className="text-2xl">User Responsibilities</strong>
            <br />
            Users are responsible for furnishing accurate and current information when submitting inquiries or requests through this landing page. Additionally, users agree not to engage in unlawful or detrimental activities, such as hacking, spamming, or transmitting malicious software.</p>
          <p className="text-lg">
            <strong className="text-2xl">Privacy and Data Handling</strong>
            <br />
            This real estate company collects, stores, and utilizes user data in compliance with applicable privacy laws. The landing page may employ third-party services or tracking technologies, like cookies or analytics tools, for which detailed information can be found in the privacy policy.
          </p>
          <p className="text-lg">
            <strong className="text-2xl">Disclaimer of Liability</strong>
            <br />
            Under no circumstances shall the real estate company be liable for damages, losses, or injuries arising from the use of this landing page or reliance on the provided information. This includes, but is not limited to, financial losses, property damage, or any direct or indirect damages.</p>
          <p className="text-lg">
            <strong className="text-2xl">Third-Party Website Links</strong>
            <br />
            Links provided on this landing page to external websites or resources do not signify endorsement or assumption of responsibility for their content, privacy practices, or availability by the real estate company.
          </p>
          <p className="text-lg">
            <strong className="text-2xl">Modification of Terms</strong>
            <br />
            The real estate company reserves the right to revise or modify these terms and conditions at any time without prior notice. Users are encouraged to periodically review the terms for updates.
          </p> 
          <p className="text-lg">
            <strong className="text-2xl">Governing Law and Jurisdiction</strong>
            <br />
            Any legal disputes arising from the use of this landing page shall be resolved within the specified jurisdiction and governed by the applicable laws pertaining to that jurisdiction.
          </p>
        </div>
      </div>
    </div>
  );
}
